/**
 * Returns the time difference in minutes between the given date and the current time.
 * @param {string} dateString - Date string in ISO format (e.g. “2024-12-04T09:24:04.459+00:00”).
 */
export function getTimeDifferenceInMinutes(dateString, currentDate) {
  if (!dateString) return 0;
  const lastCheckDate = new Date(dateString);

  const now = new Date(currentDate);

  const diffInMilliseconds = now - lastCheckDate;
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

  //  if current date on server to old
  return diffInMinutes < 0 ? 0 : diffInMinutes;
}
